import { client } from "@/graphql/lib/apollo";
import { gql } from "@apollo/client";

const SAVE_SUBSCRIPTION = gql`
  mutation SavePushSubscription($subscription: String!) {
    savePushSubscription(subscription: $subscription)
  }
`;

// export async function subscribeUser() {
//   if (typeof window === "undefined") return;

//   if (!("serviceWorker" in navigator)) return;

//   const registration = await navigator.serviceWorker.ready;

//   if (!("PushManager" in window)) return;

//   const vapidKey = process.env.NEXT_PUBLIC_VAPID_PUBLIC_KEY;
//   if (!vapidKey) {
//     console.error("Missing VAPID key");
//     return;
//   }

//   const subscription = await registration.pushManager.subscribe({
//     userVisibleOnly: true,
//     applicationServerKey: urlBase64ToUint8Array(vapidKey),
//   });

//   await client.mutate({
//     mutation: SAVE_SUBSCRIPTION,
//     variables: {
//       subscription: JSON.stringify(subscription),
//     },
//   });
// }

export async function subscribeUser() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  const registration = await navigator.serviceWorker.ready;
  if (!("PushManager" in window)) return;

  const vapidKey = process.env.NEXT_PUBLIC_VAPID_PUBLIC_KEY;
  if (!vapidKey) {
    console.error("Missing VAPID key");
    return;
  }

  let subscription = await registration.pushManager.getSubscription();

  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidKey),
    });
  }

  await client.mutate({
    mutation: SAVE_SUBSCRIPTION,
    variables: {
      subscription: JSON.stringify(subscription),
    },
  });
}

function urlBase64ToUint8Array(base64String: string) {
  if (typeof window === "undefined") return new Uint8Array();

  const padding = "=".repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, "+")
    .replace(/_/g, "/");

  const rawData = window.atob(base64);
  return new Uint8Array([...rawData].map((c) => c.charCodeAt(0)));
}
